$(document).ready(function () {
  // $(".utility-bar").show();

  var btn1 = $(".looking-btn.active").attr("data-id");
  var btn2 = $(".treat-btn.active").attr("data-id");
  var slider = $(".concern-slider");
  $(".looking-btn").on("click", function (event) {
    btn1 = $(this).attr("data-id");
    $(".looking-btn.active").not(this).removeClass("active");
    $(this).toggleClass("active");
    // // console.log("btn-1 looking", btn1);
    // // console.log("btn-2 looking ", btn2);
    showSlider(btn1, btn2);
  });

  $(".treat-btn").on("click", function (event) {
    btn2 = $(this).attr("data-id");
    $(".treat-btn.active").not(this).removeClass("active");
    $(this).toggleClass("active");
    // // console.log("btn-1 treat", btn1);
    // // console.log("btn-2 treat ", btn2);
    showSlider(btn1, btn2);
  });

  $(".looking-for-selection").on("change", function (event) {
    var optionSelected = $(this).find("option:selected");
    $(this).find("option:selected").not(this).removeClass("active");

    $(this).find("option:selected").toggleClass("active");
    btn1 = $(this).find("option:selected").attr("data-id");
    // // console.log("btn--1");

    showSlider(btn1, btn2);
  });
  $(".to-treat-selection").on("change", function (event) {
    var optionSelected = $(this).find("option:selected");
    $(this).find("option:selected").not(this).removeClass("active");

    $(this).find("option:selected").toggleClass("active");
    btn2 = $(this).find("option:selected").attr("data-id");
    // // console.log("btn--2");

    showSlider(btn1, btn2);
  });
  function showSlider(btn1, btn2) {
    // // console.log("function called, btn1", btn1);
    // // console.log("function called, btn2", btn2);

    let concat_id = btn1 + "-" + btn2;
    // // console.log("concat_id", concat_id);
    $(".concern-slider").each(function () {
      // // console.log("slide", $(this).attr("data-id"));

      if ($(this).attr("data-id") == concat_id) {
        $(this).addClass("active");
        // // console.log("if");
      } else {
        $(this).removeClass("active");
        // // console.log("else");
      }
      // if ($(th.attr("data-id") == concat_id) {
      //   $this.toggleClass('active');
      // }
      // else {
      // }
    });
  }
  //----------------Variant Swatch------------------------
  $("body").on("click", ".cstm_add_to_cart.SizeSwatch", function () {
    // // console.log("cstm_add_to_cart---");
    var avail = $(this).attr("avail");
    var dataId = $(this).attr("data-id");
    var PrdId = $(this).attr("data_prd_id");
    var _this = $(this);
    var _2tthis = this;
    var CartItem = parseInt($(this).attr("cartitem"));
    var product_handle = $(this).attr("prdHandle");
    // // console.log("-avail-", avail);
    $(this)
      .parents(".product-card-wrapper")
      .find(`.customAddToCart[data-product-id="${PrdId}"]`)
      .attr("data-id", dataId);
    $(this)
      .parents(".product-card-wrapper")
      .find(`.product-variant-id[data-product-id="${PrdId}"]`)
      .attr("value", dataId);
    $(this)
      .parents(".product-card-wrapper")
      .find(".cstm_add_to_cart.SizeSwatch")
      .removeClass("active_variant");
    $(this).addClass("active_variant");
    if (avail == "true") {
      // // console.log("trueeee",CartItem);
      var matchProLength = 0;
      $.getJSON("/cart", function (cart) {
        var matchItem = cart.items.filter((i) => {
          if (i.id == dataId) {
            matchProLength = matchProLength + i.quantity;
            return i.quantity;
          }
        });
        // // console.log("matchProLength>>",matchProLength);
        if (matchItem.length == 0) {
          // // console.log("match");
          $(this)
            .parents(".product-card-wrapper")
            .find(`.customAddToCart[data-id="${dataId}"]`)
            .html(`<span>Add to cart
                      </span>
                            <span class="sold-out-message hidden">
                              Sold out
                            </span>

                      <link href="//www.tresemme.in/cdn/shop/t/176/assets/component-loading-spinner.css?v=116724955567955766481700472530" rel="stylesheet" type="text/css" media="all">

                      <div class="loading__spinner hidden">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>`);
          $(this)
            .parents(".product-card-wrapper")
            .find(`.customAddToCart[data-id="${dataId}"]`)
            .removeAttr("disabled");
        } else {
        }
      });
    } else {
      // // console.log("else");
      _this
        .parents(".ProductItem")
        .find(`.quick_show.product-item-btn[data-id="${dataId}"]`)
        .text("Sold Out");
      _this
        .parents(".ProductItem")
        .find(`.quick_show.product-item-btn[data-id="${dataId}"]`)
        .attr("disabled", "disabled");
      _this
        .parents(".ProductItem")
        .find(`.quick_show.product-item-btn[data-id="${dataId}"]`)
        .show();
    }

    let media_attr = $(this).attr("media_attr");
    let v_price = $(this).attr("data-price");
    let v_compare_price = $(this).attr("data-compare-price");
    let v_sale_diff = $(this).attr("data-sale-diff");

    console.log("v_price", v_price);
    console.log("v_compare_price", v_compare_price);
    console.log("v_sale_diff", v_sale_diff);

    let saleDiffHTML = `<span class="sale_diff product_card_price">
      ${v_sale_diff}% Off
    </span>`;

    let regularSaleHTML = ` <div class="price price--no-compare">
    <div class="price__container">
     <div class="price__regular">
   
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span class="price-item price-item--regular">
        ${v_price}
      </span>
  </div>
  </div>
  </div>`;

    let saleHTML = `<div class="price price--on-sale">
    <div class="price__container">
    <div class="price__sale">
      <span class="visually-hidden visually-hidden--inline">Sale price</span>
     
      <span class="visually-hidden visually-hidden--inline">{{ 'products.product.price.regular_price' | t }}</span>
      <span>
        <s class="price-item price-item--regular">
        ${v_compare_price} 
        </s>
      </span>
  </div>
  </div>
  </div>`;

    let tgtImage = $(this)
      .parents(".product-card-wrapper")
      .find(".ProductItem__Image");
    // // console.log("tgtImage", tgtImage);
    tgtImage.attr("src", media_attr);
    tgtImage.removeAttr("srcset");
    let tgtProductHandle = $(this)
      .parent(".cstm_btn_div")
      .attr("product-handle");
    // // console.log("tgtProductHandle", tgtProductHandle);
    // // console.log("product-handle", product_handle);
    let tgtvid = $(this).attr("data-id");
    // // console.log(tgtvid, "tgtvid>>");
    let price_cont = $(this)
      .parents(".product-card-wrapper")
      .find(".card_price_container");
    // // console.log("price_cont", price_cont);
    if (v_compare_price > v_price) {
      console.log("if---");
      $(this)
        .parents(".product-card-wrapper")
        .find(".card_price_container")
        .html(saleHTML);
    } else {
      console.log("else---");
      $(this)
        .parents(".product-card-wrapper")
        .find(".card_price_container")
        .html(regularSaleHTML);
    }

    // fetch(
    //   "/products/" +
    //   tgtProductHandle +
    //   "?variant=" +
    //   tgtvid +
    //   "&view=collection-grid-price",
    //   {
    //     credentials: "same-origin",
    //     method: "GET",
    //   }
    // ).then(function (content) {
    //   // console.log("content", content);
    //   content.text().then(function (html) {
    //     var conhh = $(_this)
    //       .parents(".product-card-wrappe")
    //       .find(".card_price_container")
    //       .html(html);
    //   });

    // });
  });
});
//-------------------Track order---------------------
$(document).ready(function(){
      $('.track_order_btn').click(function(){
        $('.js-expected_delivery .text-medium').text('Expected date: ');
        var Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
         var trackid = $('#fname').val();
        if (trackid !== "") {
        var idLength = trackid.length;
        $('.trackOrder').css('display','none');
        $('.no-trackOrder').css('display','none');
        $('.before_loader-gif').css('display','block');
        var url = 'https://tresemme.hulsecure.in/track/trackorder';
          console.log(url,"url>>>>>>>")
        if(trackid.includes('TR') || trackid.length >= 5){
        $.ajax({
         type: "POST",
          url: url,
          contentType: 'application/json', // Set the content type to JSON
          data: JSON.stringify({ awbid: trackid }), // Convert the data to a JSON string
          dataType: 'json',
          success : function(resultData){
            console.log(resultData,"resultData>>>")
            $(".awb_reset").hide();
            $("#js-courier_awb").html("Updating");

            if(resultData.success == false){
              $('.before_loader-gif').css('display','none');
              $('.trackOrder').css('display','none');
              $('.no-trackOrder').css('display','block');
              $('#js-no-tracking_id').html(trackid);
              $('.no-track-order-discription').text('Your order has been cancelled or not confirmed');
            } else {
              var jsonArray = resultData.data;
              jsonArray.forEach(function (currentObject, index) {
                var date = currentObject.dbc6b79c7716722c;
                var status = currentObject.s12bf203295c014c;
                var awbNo = currentObject.a19bf503295d014b;
                var trackStatus = currentObject.s12bf2032967dter;
                const dateTimeObj = new Date(date);
                const formattedDate = dateTimeObj.toLocaleDateString('en-US', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                });
                var className = ".awb_"+index;
                if(trackStatus == 1){
                  $(className).show();
                  $('#js-tracking_id').html(trackid);
                  $('.trackOrder').css('display','block');
                  $('.no-trackOrder').css('display','none');
                  $('.before_loader-gif').css('display','none');
                  $(className+ ' #js-courier_awb').html(awbNo);
                  $(className+' #js-courier_name').text('Ship Rocket');
                  $(className+ " #js-expected_delivery").text(formattedDate);
                  $(className+ " #js-tracking_status").text(status);
                  $('[data-status="confirmed"]').addClass('completed');
                  var currentStatus = status.replace(/ +/g, "");
                  if(currentStatus == 'InTransit'){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="RTO"]').hide().removeClass('completed');
                  }
                  if(currentStatus == 'Dispatched'){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="Dispatched"]').addClass('completed');
                    $(className+' [data-status="RTO"]').hide().removeClass('completed');
                  }
                  if(currentStatus.match('RTO') != null){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="Dispatched"]').addClass('completed');
                    $(className+' [data-status="RTO"]').show().addClass('completed');
                    $(className+' [data-status="Delivered"]').addClass('completed');
                  }
                  if(currentStatus == 'Delivered'){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="Dispatched"]').addClass('completed');
                    $(className+' [data-status="Delivered"]').addClass('completed');
                    $(className+' [data-status="RTO"]').hide().removeClass('completed');
                  }
                  if(currentStatus.match('Delivery') != null){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="Dispatched"]').addClass('completed');
                    $(className+' [data-status="Delivered"]').removeClass('completed');
                    $(className+' [data-status="RTO"]').hide().removeClass('completed');  
                  }
                  if(currentStatus == 'Shipped' || currentStatus.match('PICKED') != null){
                    $(className+' [data-status="InTransit"]').addClass('completed');
                    $(className+' [data-status="Dispatched"]').removeClass('completed');
                    $(className+' [data-status="Delivered"]').removeClass('completed');
                    $(className+' [data-status="RTO"]').hide().removeClass('completed');  
                  }
                } else if(trackStatus == 0) {
                  $('.before_loader-gif').css('display','none');
                  $('.trackOrder').css('display','none');
                  $('.no-trackOrder').css('display','block');
                  $('#js-no-tracking_id').html(trackid);
                  $('.no-track-order-discription').text('Please Enter the correct Order Id or Awb Number');
                }
              });
            }
          },
          error : function(error){
            console.log(error,"error")
          }
        });
      }else{
            $(".before_loader-gif").css("display", "none");
            $(".trackOrder").css("display", "none");
            $(".no-trackOrder").css("display", "block");
            $("#js-no-tracking_id").html(trackid);
            $(".no-track-order-discription").text(
              "Your order has been cancelled or not confirmed"
            );
          }
      }else{
        $("#fname").css("border-color", "red");
      }
      });
      $("#fname").on("input", function () {
      $(this).css("border-color", "");
    });
  });

// --------------------Max limit---------------------
$(document).ready(function () {
  $("body").on("click", ".quantity-plus", function () {
    var quantity_plus = $(this).siblings("input").val();
    var error_max = $(this).attr("cart_error_max_limit");
    var max_limit = $(this).attr("max_limit");
    if (quantity_plus >= max_limit) {
      $(this).parents(".cart-item").find("#err_MaxLimit").text(error_max);
      $(this).attr("disabled", true);
    }
  });
});

//  _________________________ PINCODE VALIDATION ________________________________________
if (window.theme.pincodeValidatorEnable) {
  var ExistPincode = localStorage.getItem("ExistPincode");
  var PinMsg = localStorage.getItem("PinMsg");
  if (ExistPincode) {
    $(".pincode-1").val(ExistPincode);
    $(".pin-validate-btn span").text("Change");
    $(".change_pincode").show();
    $(".pin_msg").text(PinMsg).css("color", "#fff");
  } else {
    $(".pincode-validation.product-pin").show();
  }
  const pin_list_1 = window.theme.pincodeList_1;
  const pin_list_2 = window.theme.pincodeList_2;
  $(".pin-validate-btn").click(function (i) {
    $(".dis_error-msg").hide();
    var popup_open = $(".popup-pincode").css("display");
    if (popup_open == "block") {
      var pin_1 = $(".popup-pincode-inner .pincode-1");
      var pincode_1 = pin_1.val();
    } else {
      var pin_1 = $(this).parent(".pincode-validator").find("input.pincode-1");
      var pincode_1 = pin_1.val();
    }
    if (/^(\d{6})$/.test(pincode_1)) {
      if ($.inArray(pincode_1, pin_list_1) > -1) {
        localStorage.setItem("ExistPincode", pincode_1);
        localStorage.setItem("storepincode", pincode_1);
        $(".pincode-1").attr("placeholder", "Enter PIN").css("color", "#fff");
        if (popup_open == "block") {
          setTimeout(function () {
            $(".popup-pincode").hide();
          }, 500);
        }
        $(".pincode-1").val(pincode_1);
        $(".pin-validate-btn span").text("Change");
        $(".pincode-validation.product-pin").hide();
        $(".change_pincode").show();
        location_1 = array_location[0];
        localStorage.setItem("currentLocationId", location_1);
        // // console.log(location_1);
        location.reload();
      } else if ($.inArray(pincode_1, pin_list_2) > -1) {
        localStorage.setItem("ExistPincode", pincode_1);
        localStorage.setItem("storepincode", pincode_1);
        $(".pincode-1").attr("placeholder", "Enter PIN").css("color", "#fff");
        if (popup_open == "block") {
          setTimeout(function () {
            $(".popup-pincode").hide();
          }, 500);
        }
        $(".pincode-1").val(pincode_1);
        $(".pin-validate-btn span").text("Change");
        $(".pincode-validation.product-pin").hide();
        $(".change_pincode").show();
        location_1 = array_location[1];
        localStorage.setItem("currentLocationId", location_1);
        // // console.log(location_1);
        location.reload();
      } else {
        pin_1
          .focus()
          .attr("placeholder", "Delivery not available..")
          .css("color", "red");
        //$('.pincode-1').val('');
        $(".pin_msg")
          .text(
            "Apologies, we do not currently service your location. We will be there soon!"
          )
          .css("color", "red");
        $(".pin-validate-btn span").text("Submit");
        localStorage.setItem("ExistPincode", "");
        localStorage.setItem("storepincode", "");
        localStorage.setItem("PinMsg", "");
        $(".change_pincode").hide();
        $(".pincode-validation.product-pin").show();
        $(".shopify-payment-button__button").attr("disabled", "disabled");
      }
    } else {
      pin_1.focus().attr("placeholder", "Invalid PIN").css("color", "red");
      $(".pincode-1").val("");
      localStorage.setItem("PinMsg", "");
      $(".pin_msg").text("");
      $(".change_pincode").hide();
      $(".pincode-validation.product-pin").show();
      $(".pin-validate-btn span").text("Submit");
      localStorage.setItem("ExistPincode", "");
      localStorage.setItem("storepincode", "");
      $(".shopify-payment-button__button").attr("disabled", "disabled");

      return false;
    }
  });
  const atc_btn = $(".ProductForm__AddToCart").click(function (evt) {
    var ExistPincode = localStorage.getItem("ExistPincode");
    if (!ExistPincode) {
      evt.preventDefault();
      evt.stopPropagation();
      $(".popup-pincode").show();
    }
  });
  $(".hdrpin").click(function (evt) {
    $(".popup-pincode").show();
  });
  $(".popup-pincode-inner .close").on("click", function () {
    var closePopup = localStorage.setItem("closePop", "true");
    $(".popup-pincode").hide();
  });
  // if (closePopup == "true" || ExistPincode) {
  //   $(".popup-pincode").hide();
  // } else if (ExistPincode != "true") {
  //   $(".popup-pincode").show();
  // }
}
window.getCart = function (variantID, productID) {
  var _formHTML = `<product-form>
  <form id="customProductForm" method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${variantID}" data-product-id="${productID}" class="product-variant-id">
    <button id="-submit" type="submit" name="add" class="customAddToCart quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="-submit title--${productID}" aria-live="polite" data-product-id="${productID}" data-id="${variantID}" data-sold-out-message="true"  data-variant-id="${variantID}" data-list-position=""  data-product-vendor="Tresemme India">
      <span>Add to cart
</span>
      <span class="sold-out-message hidden">
        Sold out
      </span>

<link href="//www.tresemme.in/cdn/shop/t/191/assets/component-loading-spinner.css?v=116724955567955766481707124490" rel="stylesheet" type="text/css" media="all">

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
<span id="productAvailability" data-soldout="false"></span>
</button><input type="hidden" name="product-id" value="${productID}"><input type="hidden" name="section-id" value="template--customProductForm-${productID}-${variantID}"></form></product-form>`;
  let customForm = document.getElementById("customForm");

  customForm.innerHTML = "";
  customForm.innerHTML = _formHTML;

  var productForm = customProductForm;

  // $(".drawer").addClass("active");
  this.cart = document.querySelector("cart-drawer");
  let cartDrawer = this.cart;

  this.submitButton = document.querySelector('[type="submit"]');
  // let btn_id = submitButton.getAttribute("data--prodc_id");
  // let addData = true;

  let submitButton = this.submitButton;
  // let cartDrawer = this.cart;
  // let handleErrorMessageFunc = window.handleErrorMessage();
  // let loadindSpinner = this.querySelector(".loading__spinner");
  // let error = this.error;
  let btn_id = submitButton.getAttribute("data-id");
  // let productForm = this.form;
  let addData = true;

  // let submitButton = this.submitButton;
  // let cartDrawer = this.cart;
  // let handleErrorMessageFunc = this.handleErrorMessage();
  let loadindSpinner = document.querySelector(".loading__spinner");
  let error = this.error;
  // let btn_id = submitButton.getAttribute("data-id");
  // let productForm = this.form;
  // let addData = true;

  let productAvailability = document.getElementById("productAvailability");

  var cartContents = fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      // console.log("data", data);
      if (data.item_count == 0) {
        // console.log("empty cart");
        if (submitButton.getAttribute("aria-disabled") === "true") return;

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        loadindSpinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // console.log("productForm--", productForm);
        const formData = new FormData(productForm);
        // console.log("formData--", formData);
        if (cartDrawer) {
          formData.append(
            "sections",
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // console.log("if---");
              productAvailability.setAttribute("data-soldout", true);
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              const soldOutMessage =
                submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              submitButton.setAttribute("aria-disabled", true);
              submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              error = true;
              return;
            } else if (!cartDrawer) {
              // console.log("else if---");
              window.location = window.routes.cart_url;
              return;
            }

            if (!error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            cartDrawer.renderContents(response);

            error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            if (cartDrawer && cartDrawer.classList.contains("is-empty"))
              cartDrawer.classList.remove("is-empty");
            if (!error) submitButton.removeAttribute("aria-disabled");
            loadindSpinner.classList.add("hidden");
          });
      } else {
        data.items.forEach(function (i, item) {
          // console.log("i==", i);
          // console.log("item", item);
          // console.log("i.id", i.id);
          // console.log("btn_id", btn_id);
          if (i.id.toString() == btn_id) {
            // console.log("id matched");
            if (i.quantity >= 4) {
              addData = false;
            } else {
              addData = true;
            }
            return;
          }
        });

        if (addData == true) {
          if (submitButton.getAttribute("aria-disabled") === "true") return;

          // handleErrorMessageFunc;

          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
          loadindSpinner.classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          // console.log("productForm--", productForm);

          const formData = new FormData(productForm);
          // console.log("formData---", formData);
          if (cartDrawer) {
            formData.append(
              "sections",
              cartDrawer.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            cartDrawer.setActiveElement(document.activeElement);
          }
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                // console.log("if---");
                productAvailability.setAttribute("data-soldout", true);

                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                // this.handleErrorMessage(response.description);

                const soldOutMessage =
                  submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                submitButton.setAttribute("aria-disabled", true);
                submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                error = true;
                return;
              } else if (!cartDrawer) {
                // console.log("else if---");
                window.location = window.routes.cart_url;
                return;
              }

              if (!error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              cartDrawer.renderContents(response);

              error = false;
            })
            .catch((e) => {
              // console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              if (cartDrawer && cartDrawer.classList.contains("is-empty"))
                cartDrawer.classList.remove("is-empty");
              if (!error) submitButton.removeAttribute("aria-disabled");
              loadindSpinner.classList.add("hidden");
            });
        }
      }
    });
};
window.handleErrorMessage = function (errorMessage = false) {
  if (document.hideErrors) return;

  window.errorMessageWrapper =
    this.errorMessageWrapper ||
    this.querySelector(".product-form__error-message-wrapper");
  if (!this.errorMessageWrapper) return;
  this.errorMessage =
    this.errorMessage ||
    this.errorMessageWrapper.querySelector(".product-form__error-message");

  this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

  if (errorMessage) {
    this.errorMessage.textContent = errorMessage;
  }
};
// -------------store parameters in session storage -----------------------

(function () {
  // Function to set session storage with expiry
  function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  // Function to get session storage item with expiry check
  function getWithExpiry(key) {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  // Function to get URL parameters and store them in session storage
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const utm_term = params.get("utm_term");
    const utm_content = params.get("utm_content");
    const ttl = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (utm_term) {
      setWithExpiry("utm_term", utm_term, ttl);
    }
    if (utm_content) {
      setWithExpiry("utm_content", utm_content, ttl);
    }
  }

  // Call the function to store UTM parameters
  getUrlParams();

  // Example of retrieving the stored values
  const storedUtmTerm = getWithExpiry("utm_term");
  const storedUtmContent = getWithExpiry("utm_content");

  console.log("Stored UTM Term:", storedUtmTerm);
  console.log("Stored UTM Content:", storedUtmContent);
})();


 // this is for for redirection

let accountLoginUrl = window.location.href;
        if(accountLoginUrl.includes('/account/login')){
        window.location.href = '/';
      }

let cartUrl = window.location.href;
        if(cartUrl.includes('/cart')){
        window.location.href = '/';
      }





let accountRegisterUrl = window.location.href;
        if(accountRegisterUrl.includes('/account/register')){
        window.location.href = '/';
      }

let trackOrderUrl = window.location.href;
        if(trackOrderUrl .includes('/pages/track-order')){
        window.location.href = '/';
      }

// let virtualStyler = window.location.href;
//         if(accountRegisterUrl.includes('/pages/virtual-styler')){
//         window.location.href = '/';
//       }
 // this is end  for redirection

// this is for pincode checker

let pincode_service = document.querySelector('.pincode_service').style.display = "none"
let WhatsAppButton__root = document.querySelector('.WhatsAppButton__root').style.display = "none"





